(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scratch-win-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseOutcomes(root) {
      var el = root.querySelector('[data-nogu-swp-outcomes-json]');
      if (!el || !el.textContent) return [];
      try {
        return JSON.parse(el.textContent.trim());
      } catch (e) {
        return [];
      }
    }

    function pickWeighted(outcomes) {
      var total = 0;
      for (var i = 0; i < outcomes.length; i++) total += Math.max(1, parseInt(outcomes[i].weight, 10) || 1);
      var r = Math.random() * total;
      var acc = 0;
      for (var j = 0; j < outcomes.length; j++) {
        acc += Math.max(1, parseInt(outcomes[j].weight, 10) || 1);
        if (r <= acc) return outcomes[j];
      }
      return outcomes[outcomes.length - 1];
    }

    function storageKey(root) {
      return 'nogu_swp:' + (root.getAttribute('data-storage-key') || 'default');
    }

    function canShow(root) {
      if (root.getAttribute('data-design-mode') === 'true') return true;
      if (root.getAttribute('data-live-enabled') !== 'true') return false;
      var days = parseInt(root.getAttribute('data-cooldown-days'), 10);
      if (isNaN(days) || days < 0) days = 30;
      if (days === 0) return true;
      try {
        var raw = localStorage.getItem(storageKey(root));
        if (!raw) return true;
        var ts = parseInt(raw, 10);
        if (isNaN(ts)) return true;
        return Date.now() - ts > days * 86400000;
      } catch (e) {
        return true;
      }
    }

    function markDismissed(root) {
      try {
        localStorage.setItem(storageKey(root), String(Date.now()));
      } catch (e) {}
    }

    function qs(root, sel) {
      return root.querySelector(sel);
    }

    function show(el, on) {
      if (!el) return;
      if (on) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    }

    function setStep(root, name) {
      var panels = root.querySelectorAll('[data-nogu-swp-step]');
      for (var i = 0; i < panels.length; i++) {
        var p = panels[i];
        show(p, p.getAttribute('data-nogu-swp-step') === name);
      }
      if (name === 'claim' && root.__noguSwpChosen) {
        var cid = String(root.__noguSwpChosen.id);
        root.querySelectorAll('[data-nogu-swp-claim-id]').forEach(function (el) {
          show(el, el.getAttribute('data-nogu-swp-claim-id') === cid);
        });
      }
    }

    function trapFocus(dialog, e) {
      var focusables = dialog.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );
      var list = [];
      for (var i = 0; i < focusables.length; i++) {
        if (focusables[i].offsetParent !== null) list.push(focusables[i]);
      }
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function initRoot(root) {
      if (root.getAttribute('data-nogu-swp-initialized') === '1') return;
      root.setAttribute('data-nogu-swp-initialized', '1');

      var outcomes = parseOutcomes(root);
      if (!outcomes.length) return;

      var chosen = pickWeighted(outcomes);
      root.__noguSwpChosen = chosen;
      var teaser = qs(root, '[data-nogu-swp-teaser]');
      var overlay = qs(root, '[data-nogu-swp-overlay]');
      var dialog = qs(root, '[data-nogu-swp-dialog]');
      var canvas = qs(root, '[data-nogu-swp-canvas]');
      var prizeHead = qs(root, '[data-nogu-swp-prize-head]');
      var prizeSub = qs(root, '[data-nogu-swp-prize-sub]');
      var reducedBtn = qs(root, '[data-nogu-swp-reveal-fallback]');
      var skipIntro = root.getAttribute('data-skip-intro') === 'true';
      var showEmail = root.getAttribute('data-show-email-step') !== 'false';
      var threshold = parseInt(root.getAttribute('data-threshold-pct'), 10);
      if (isNaN(threshold) || threshold < 5) threshold = 70;
      var brush = parseInt(root.getAttribute('data-brush-size'), 10);
      if (isNaN(brush) || brush < 8) brush = 28;
      var delayMs = parseInt(root.getAttribute('data-delay-ms'), 10) || 0;
      var scrollPct = parseInt(root.getAttribute('data-scroll-pct'), 10);
      var exitIntent = root.getAttribute('data-exit-intent') === 'true';
      var designMode = root.getAttribute('data-design-mode') === 'true';
      var liveEnabled = root.getAttribute('data-live-enabled') === 'true';

      var lastFocus = null;
      var opened = false;
      var scratching = false;
      var revealed = false;
      var ctx = null;
      var w = 0,
        h = 0;
      var reducedMotion = false;
      try {
        reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      function setPanelImageUrl() {
        var url = chosen.image || root.getAttribute('data-fallback-panel-img');
        var mc = qs(root, '[data-nogu-swp-media-col]');
        if (url) {
          var safe = String(url).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
          root.style.setProperty('--nogu-swp-media-url', 'url("' + safe + '")');
          if (mc) mc.setAttribute('aria-hidden', 'false');
        } else {
          root.style.removeProperty('--nogu-swp-media-url');
          if (mc) mc.setAttribute('aria-hidden', 'true');
        }
      }

      function applyPrizeToDom() {
        prizeHead.textContent = chosen.headline || '';
        prizeSub.textContent = chosen.subheadline || '';
        setPanelImageUrl();
      }

      function openModal() {
        if (opened) return;
        opened = true;
        setPanelImageUrl();
        lastFocus = document.activeElement;
        show(overlay, true);
        show(dialog, true);
        if (skipIntro || reducedMotion) {
          goScratch();
        } else {
          setStep(root, 'intro');
        }
        var toFocus = dialog.querySelector('button, [href], input');
        if (toFocus) toFocus.focus();
      }

      function goScratch() {
        applyPrizeToDom();
        setStep(root, 'scratch');
        if (reducedMotion) {
          show(canvas, false);
          show(reducedBtn, true);
        } else {
          show(canvas, true);
          show(reducedBtn, false);
          requestAnimationFrame(function () {
            requestAnimationFrame(setupCanvas);
          });
        }
      }

      function setupCanvas() {
        var wrap = qs(root, '[data-nogu-swp-scratch-wrap]');
        if (!wrap || !canvas) return;
        var rect = wrap.getBoundingClientRect();
        w = Math.max(200, Math.floor(rect.width));
        h = Math.max(200, Math.floor(rect.height));
        canvas.width = w;
        canvas.height = h;
        ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.globalCompositeOperation = 'source-over';
        var fg = root.getAttribute('data-scratch-fg');
        var tint = root.getAttribute('data-scratch-tint') || '#b8b8b8';
        if (fg) {
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            ctx.drawImage(img, 0, 0, w, h);
            ctx.globalCompositeOperation = 'destination-out';
            scratching = true;
          };
          img.onerror = function () {
            fillTint();
          };
          img.src = fg;
        } else {
          fillTint();
        }
        function fillTint() {
          ctx.fillStyle = tint;
          ctx.fillRect(0, 0, w, h);
          ctx.globalCompositeOperation = 'destination-out';
          scratching = true;
        }
      }

      function eraseAt(clientX, clientY) {
        if (!ctx || !scratching || revealed) return;
        var rect = canvas.getBoundingClientRect();
        var x = clientX - rect.left;
        var y = clientY - rect.top;
        var scaleX = canvas.width / rect.width;
        var yscale = canvas.height / rect.height;
        x *= scaleX;
        y *= yscale;
        ctx.beginPath();
        ctx.arc(x, y, brush, 0, Math.PI * 2);
        ctx.fill();
        maybeReveal();
      }

      function sampleCleared() {
        if (!ctx || !w || !h) return 0;
        var step = 6;
        var cleared = 0,
          total = 0;
        var data;
        try {
          data = ctx.getImageData(0, 0, w, h).data;
        } catch (e) {
          return 0;
        }
        for (var x = 0; x < w; x += step) {
          for (var y = 0; y < h; y += step) {
            var i = (y * w + x) * 4 + 3;
            total++;
            if (data[i] < 32) cleared++;
          }
        }
        return total ? (cleared / total) * 100 : 0;
      }

      var checkTimer = null;
      function maybeReveal() {
        if (revealed) return;
        if (checkTimer) return;
        checkTimer = setTimeout(function () {
          checkTimer = null;
          if (sampleCleared() >= threshold) finishReveal();
        }, 120);
      }

      function finishReveal() {
        if (revealed) return;
        revealed = true;
        scratching = false;
        var titleEl = qs(root, '[data-nogu-swp-revealed-title]');
        if (titleEl) titleEl.textContent = chosen.headline || '';
        setStep(root, 'revealed');
      }

      function goClaim() {
        if (!showEmail) {
          goSuccess();
          return;
        }
        var sp = chosen.signupProvider || 'shopify';
        if (sp === 'none') {
          goSuccess();
          return;
        }
        setStep(root, 'claim');
        var panel = root.querySelector('[data-nogu-swp-claim-id="' + String(chosen.id) + '"]');
        var em = panel && panel.querySelector('input[type="email"]');
        if (em) em.focus();
      }

      function goSuccess() {
        var codeEl = qs(root, '[data-nogu-swp-code]');
        if (codeEl) codeEl.textContent = chosen.code || '';
        setStep(root, 'success');
        var copyBtn = qs(root, '[data-nogu-swp-copy]');
        if (copyBtn) copyBtn.focus();
      }

      function closeAll() {
        show(overlay, false);
        show(dialog, false);
        opened = false;
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      function wire() {
        if (teaser)
          teaser.addEventListener('click', function () {
            openModal();
          });

        qs(root, '[data-nogu-swp-to-scratch]') &&
          qs(root, '[data-nogu-swp-to-scratch]').addEventListener('click', goScratch);
        qs(root, '[data-nogu-swp-to-claim]') &&
          qs(root, '[data-nogu-swp-to-claim]').addEventListener('click', goClaim);
        qs(root, '[data-nogu-swp-reveal-fallback]') &&
          qs(root, '[data-nogu-swp-reveal-fallback]').addEventListener('click', finishReveal);

        root.querySelectorAll('[data-nogu-swp-skip-to-success]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            goSuccess();
          });
        });

        root.querySelectorAll('[data-nogu-swp-dismiss]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            markDismissed(root);
            closeAll();
            show(teaser, false);
          });
        });

        qs(root, '[data-nogu-swp-close]') &&
          qs(root, '[data-nogu-swp-close]').addEventListener('click', function () {
            markDismissed(root);
            closeAll();
            show(teaser, false);
          });

        overlay &&
          overlay.addEventListener('click', function () {
            markDismissed(root);
            closeAll();
            show(teaser, false);
          });

        dialog.addEventListener('keydown', function (e) {
          if (e.key !== 'Tab') return;
          trapFocus(dialog, e);
        });

        document.addEventListener('keydown', function (e) {
          if (!opened || e.key !== 'Escape') return;
          var onSuccess = root.getAttribute('data-esc-close-success') === 'true';
          var stepSuccess = qs(root, '[data-nogu-swp-step="success"]');
          var onSucc = stepSuccess && !stepSuccess.hasAttribute('hidden');
          if (onSucc && !onSuccess) return;
          markDismissed(root);
          closeAll();
          show(teaser, false);
        });

        if (canvas && !reducedMotion) {
          canvas.addEventListener('pointerdown', function (e) {
            try {
              canvas.setPointerCapture(e.pointerId);
            } catch (err) {}
            eraseAt(e.clientX, e.clientY);
          });
          canvas.addEventListener('pointermove', function (e) {
            var drawing = false;
            try {
              drawing = canvas.hasPointerCapture(e.pointerId) || e.buttons === 1;
            } catch (err2) {
              drawing = e.buttons === 1;
            }
            if (!drawing) return;
            eraseAt(e.clientX, e.clientY);
          });
        }

        var copyMsg = root.getAttribute('data-copy-done') || 'Copied';
        qs(root, '[data-nogu-swp-copy]') &&
          qs(root, '[data-nogu-swp-copy]').addEventListener('click', function () {
            var code = chosen.code || '';
            var status = qs(root, '[data-nogu-swp-copy-status]');
            function done(ok) {
              if (status) status.textContent = ok ? copyMsg : '';
            }
            if (!code) return done(false);
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(code).then(function () {
                done(true);
              }, function () {
                done(false);
              });
            } else {
              done(false);
            }
          });

        var iframeName = root.getAttribute('data-form-target');
        if (iframeName) {
          root.querySelectorAll('[data-nogu-swp-claim-id] form').forEach(function (form) {
            form.setAttribute('target', iframeName);
            form.setAttribute('method', 'post');
            form.addEventListener('submit', function () {
              var panel = form.closest('[data-nogu-swp-claim-id]');
              var errBox = panel && panel.querySelector('[data-nogu-swp-form-errors]');
              if (errBox) {
                errBox.setAttribute('hidden', '');
                errBox.textContent = '';
              }
            });
          });
        }

        document.addEventListener('klaviyoForms', function (e) {
          if (!opened || !root.__noguSwpChosen) return;
          var ch = root.__noguSwpChosen;
          if ((ch.signupProvider || 'shopify') !== 'klaviyo') return;
          var fid = ch.klaviyoFormId;
          if (!fid) return;
          var d = e.detail || {};
          var detailId = d.formId || d.formID;
          if (detailId == null && d.metaData) detailId = d.metaData.formId;
          if (String(detailId) !== String(fid)) return;
          markDismissed(root);
          goSuccess();
          show(overlay, true);
          show(dialog, true);
          show(teaser, false);
          var copyBtn = qs(root, '[data-nogu-swp-copy]');
          if (copyBtn) copyBtn.focus();
        });

        var iframe = document.getElementById('nogu-swp-iframe-' + root.getAttribute('data-section-id'));
        if (iframe) {
          iframe.addEventListener('load', function () {
            try {
              var href = iframe.contentWindow && iframe.contentWindow.location.href;
              if (!href || href === 'about:blank') return;
              if (href.indexOf('customer_posted=true') !== -1 || href.indexOf('contact_posted=true') !== -1) {
                markDismissed(root);
                goSuccess();
                show(overlay, true);
                show(dialog, true);
                show(teaser, false);
                var copyBtn = qs(root, '[data-nogu-swp-copy]');
                if (copyBtn) copyBtn.focus();
              }
            } catch (err) {}
          });
        }

        function revealTeaser() {
          if (!canShow(root) && !designMode) return;
          show(teaser, true);
        }

        function maybeAutoOpen() {
          if (!canShow(root) && !designMode) return;
          if (designMode && !liveEnabled) return;
          openModal();
        }

        if (designMode && liveEnabled) {
          revealTeaser();
        } else if (designMode && !liveEnabled) {
          revealTeaser();
        } else {
          if (!canShow(root)) return;
          if (delayMs > 0) {
            setTimeout(function () {
              if (!scrollPct && !exitIntent) maybeAutoOpen();
              else revealTeaser();
            }, delayMs);
          } else if (!scrollPct && !exitIntent) {
            maybeAutoOpen();
          } else {
            revealTeaser();
          }
        }

        if (scrollPct > 0 && scrollPct <= 100) {
          function onScroll() {
            var doc = document.documentElement;
            var max = doc.scrollHeight - doc.clientHeight;
            if (max <= 0) return;
            var p = (doc.scrollTop / max) * 100;
            if (p >= scrollPct) {
              window.removeEventListener('scroll', onScroll);
              if (delayMs) setTimeout(maybeAutoOpen, delayMs);
              else maybeAutoOpen();
            }
          }
          window.addEventListener('scroll', onScroll, { passive: true });
        }

        if (exitIntent) {
          document.addEventListener('mouseout', function (e) {
            if (!e.relatedTarget && e.clientY < 12) {
              if (delayMs) setTimeout(maybeAutoOpen, delayMs);
              else maybeAutoOpen();
            }
          });
        }
      }

      wire();
    }

    function boot() {
      document.querySelectorAll('.nogu-swp[data-section-id]').forEach(initRoot);
    }

    document.addEventListener('shopify:section:load', function (ev) {
      var el = ev.target;
      if (!el || !el.querySelector) return;
      el.querySelectorAll('.nogu-swp[data-section-id]').forEach(initRoot);
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
